import { systemController } from '@/tauri/controller/system';
import { isTauri } from '@/tauri/utils';
import { logger } from '@/utils/logger/logger';

/**
 * Disarms the Rust boot watchdog once the app shell mounts. If JavaScript never
 * gets this far, Rust reports the stall. Fire-and-forget: failures log, never throw.
 */
export function signalDesktopBootComplete(): void {
  if (!isTauri()) return;
  systemController.mark_webview_boot_complete().catch(() => {
    logger.warn('[boot_watchdog] failed to signal boot complete');
  });
}
